
import React from "react";
import { Button } from "@/components/ui/button";

interface AssignmentActionsProps {
  onCancel: () => void;
  onSubmit: () => void;
}

export const AssignmentActions: React.FC<AssignmentActionsProps> = ({
  onCancel,
  onSubmit,
}) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white p-4 border-t border-gray-200">
      <div className="flex justify-between gap-4">
        <Button 
          type="button" 
          variant="outline"
          className="flex-1"
          onClick={onCancel}
        >
          Annuler
        </Button>
        <Button 
          type="submit"
          className="flex-1 bg-[#BD1E28] hover:bg-[#A01822] text-white"
          onClick={onSubmit}
        >
          Enregistrer
        </Button>
      </div>
    </div>
  );
};
